﻿import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { InformationService } from '../../../services/information.service';
import { BuildingService } from '../../../services/building.service';
import { SharedService } from '../../../services/shared.service';
import { UnitCount } from '../../../viewmodel'; 
import { Animations } from '../../common/animations';
import { AppConfig } from '../../../app.config';

@Component({
  selector: 'app-unitcount',
  templateUrl: './unitcount.component.html',
  providers: [InformationService, BuildingService],
  animations: [Animations.flyInOut]      
})
export class UnitCountComponent implements OnInit {

    public floornumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/] 
    public unitsnumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/] 
    public ZR23Url: string = AppConfig.config.ZR23Url; 
    animate: string = 'active';
    title: string = 'Unit Count';
    projectId: number = 0;
    buildingId: number = 0; 
    projBuildingId: number = 0;
    devProjBuildingId: number = 0;
    siteProjBuildingId: number = 0; 
    trackingId: number = 0;  
    entityId: number = 0; 
    questionType: number = 415; 
    buildingAddress: string = ''; 
    HFO: string = ''; //Housing fund Option

    pageError: any = [];
    pageSuccess: any = [];
    isEdit: boolean = false;
    submitted: boolean = false;
    questionForm: FormGroup;
    model: UnitCount;   
    serverValidationErrors: Array<string> = ['Total residential units and total residential square footage must be greater than 0', 
                                             'Total residential units must be greater than 0 and the total residential square footage must be greater than or equal to the total MIH square footage',
                                             'Total residential units must be greater than 0',    
                                             'Total residential units for this building must be greater than or equal to the sum of MIH units and super’s units and the total residential square footage must be greater than 0',
                                             'Total residential square footage must be greater than 0',
                                             'Total residential units for this building must be greater than or equal to the sum of MIH units and super’s units and the total residential square footage must be greater than or equal to the total MIH square footage',
                                             'Total residential units for this building must be greater than or equal to the sum of MIH units and super’s units',
                                             'Total residential square footage must be greater than or equal to the total MIH square footage'];

    constructor(private router: Router
	, private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService
        ) {

        this.model = new UnitCount();
        this.model.ProjectId = this.projectId;
        
    }
    ngOnInit() {
 
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null)
                this.projectId = this.model.ProjectId = ids.projectId;
        }
        else {
            if (this.model.ProjectId == 0 && this.projectId == 0)
                this.sharedService.navigateHome();
        }

        let bqp = this.sharedService.getJsonData('BuildingQuestionParam');
        if (bqp != null) {
            this.devProjBuildingId = this.model.DevProjectBuildingId = bqp.devProjectBuildingId;
            this.siteProjBuildingId = this.model.SiteProjectBuildingId = bqp.siteProjectBuildingId;
            this.buildingId = this.model.BuildingId = bqp.bldgId;
            this.projBuildingId = this.devProjBuildingId == null ? this.siteProjBuildingId : this.devProjBuildingId;
            if (bqp.buildingAddress != null || bqp.buildingAddress == '')
                this.buildingAddress = '- ' + bqp.buildingAddress;
        }
        else {
            this.sharedService.navigateSummary();
        }

        if (this.projBuildingId == null || this.buildingId == null) 
            this.sharedService.navigateSummary();

        this.questionForm = this.frmBuilder.group({
            floorarea: [null, [Validators.required, Validators.pattern('[0-9]*')]],
            units: [null, [Validators.required, Validators.pattern('[0-9]*')]]    
        });

        //get the payment In Liu info
        if (bqp != null) {
            this.informationService.getQuestionByType(this.projectId, 'AHF')
                .subscribe(
                success => {
                    if (!success.Success)
                        this.showError(success.StatusMessage);
                    else {
                        if (success.Result != null) {
                            this.HFO = success.Result.Hfo;
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                })
        }

        //get floorArea data
        if (bqp != null) { 
        this.informationService.GetProjectBuildingFloorAreaUnitCount(this.devProjBuildingId, this.siteProjBuildingId)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {
                        this.model.UnitCount = success.Result.UnitCount;
                        this.model.Floorarea = success.Result.FloorArea;
                        if (this.model.UnitCount > 0 && this.model.Floorarea>0)
                            this.isEdit = true; 
                    }
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })
        }
    }

    next(button) {
        this.submitted = true;
        if (!this.questionForm.valid) {
           return false;
        }

        // var alertMessage = this.validateForm();
        // if (alertMessage != '') {
        //     this.showErrorAlert(alertMessage);
        //     return false;
        // }

        if (this.model.Floorarea == null || this.model.UnitCount == null) {
             return false;
        }
        
        this.model.IsValid = true;
        this.informationService.SaveProjectBuildingFloorAreaUnitCount(this.model)        
            .subscribe(
            success => {
                if (!success.Success) {                    
                    if (success.StatusMessage != null && this.serverValidationErrors.indexOf(success.StatusMessage) !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else {
                        this.showError(success.StatusMessage);
                    }
				}
                else {
                    if (button == 'NEXT') {
                        if (this.HFO == 'N')
                            this.router.navigate(["/buildings/publicfunding"]);
                        else {
                            this.sharedService.navigateSummary();
                        }
                    }
                    else if (button == 'LATER')
                        this.sharedService.navigateSummary();
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })
    }

    PopulateData(question) {
        this.model.UnitCount = question.ResidentialUnits;
        this.model.Floorarea = question.FloorArea;
    }

    PopulateQuestionAndAddress(buildings) {
        if (buildings == null || buildings.length == 0)
            return false; 

        var item = buildings[0];
        this.buildingAddress = item.HouseNumber + ' ' + item.StreetName;
    }

    // validateForm() {
    //     var floorarea = +this.model.Floorarea; //cast of string to number
    //     var unitCount = +this.model.UnitCount;
    //     var msg = '';
    //     if (floorarea == 0 && unitCount == 0)
    //         msg = 'Total residential square footage and residential units must be greater than 0';
    //     else if (floorarea == 0)
    //         msg = 'Total residential square footage must be greater than 0';
    //     else if (unitCount == 0)
    //         msg = 'Total residential units must be greater than 0';

    //     return msg; 
    // }

    previous() {
        this.sharedService.navigateSummary();
    }
    home() {
        this.sharedService.navigateHome();
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

}
